import type { ResolvedVisualThemeId } from './visualThemeTypes';

/**
 * The *resolved* palette (auto → sun/cosmos). Sound helpers must use this
 * to pick the correct audio file — using the raw preference would always
 * yield the neutral sound when the user has selected `auto`.
 */
let activeResolved: ResolvedVisualThemeId = 'neutral';

export function setActiveResolvedVisualThemeId(id: ResolvedVisualThemeId): void {
  activeResolved = id;
}

export function getActiveResolvedVisualThemeId(): ResolvedVisualThemeId {
  return activeResolved;
}
